import { render, staticRenderFns } from "./AddCollaboratorModal.vue?vue&type=template&id=93a5ed32&scoped=true&"
import script from "./AddCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./AddCollaboratorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCollaboratorModal.vue?vue&type=style&index=0&id=93a5ed32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a5ed32",
  null
  
)

export default component.exports